/**
 * The single page's section anchors.
 *
 * These ids are rendered by the landing sections and pointed at by the header
 * and footer, so they live in one place rather than as loose strings.
 */
export const SECTIONS = {
  problem: 'the-problem',
  howItWorks: 'how-it-works',
  app: 'the-app',
  platform: 'platform',
  manufacturers: 'for-manufacturers',
  retailers: 'for-retailers',
  pilot: 'pilot',
  faq: 'faq',
  contact: 'contact',
} as const;

export type SectionId = (typeof SECTIONS)[keyof typeof SECTIONS];

/**
 * `/#how-it-works` — a router path, not a bare fragment, so the same link
 * works from the legal pages as well as from the page itself.
 */
export const anchor = (id: SectionId) => `/#${id}`;
